import { render, staticRenderFns } from "./DoctorClinicJoinRequest.vue?vue&type=template&id=526f3bb2&"
import script from "./DoctorClinicJoinRequest.vue?vue&type=script&lang=js&"
export * from "./DoctorClinicJoinRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports